var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown" }, [
    _c(
      "a",
      {
        staticClass: "btn btn-sm dropdown-toggle clickable",
        staticStyle: { transition: "all 0.4s ease" },
        attrs: { "data-toggle": "dropdown" },
      },
      [_vm._v("\n    " + _vm._s(_vm.currentText) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dropdown-menu" },
      [
        _vm._l(_vm.options, function (item, index) {
          return _vm._t(
            "items",
            function () {
              return [
                _c(
                  "a",
                  {
                    key: index,
                    staticClass: "dropdown-item clickable",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.select(item)
                      },
                    },
                  },
                  [
                    _vm.isSelected(item)
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v("done"),
                        ])
                      : _vm._e(),
                    _vm._v("\n        " + _vm._s(item.name) + "\n      "),
                  ]
                ),
              ]
            },
            { item: item }
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }